var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTransportFerry({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 16V2h12l3 6h5l-4 8H2ZM4 4h2v4H4V4Zm14 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5.5-7H8v4h6.5l-2-4Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18a4.236 4.236 0 0 0-3.789 2.342l-.105.21a1 1 0 1 0 1.788.895l.106-.21a2.236 2.236 0 0 1 4 0l.106.21a1 1 0 0 0 1.788 0l.106-.21a2.236 2.236 0 0 1 4 0l.105.21a1 1 0 0 0 1.79 0l.105-.21a2.236 2.236 0 0 1 4 0l.105.21a1 1 0 0 0 1.79-.894l-.106-.211A4.236 4.236 0 0 0 15 19.245a4.236 4.236 0 0 0-6 0A4.236 4.236 0 0 0 6 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTransportFerry);
export default __webpack_public_path__ + "static/media/ic_action_transport_ferry.a570fd12571df69417c57b7aed8001d5.svg";
export { ForwardRef as ReactComponent };